import { render } from "./InitializeSaveAddress.vue?vue&type=template&id=210c96b0"
import script from "./InitializeSaveAddress.vue?vue&type=script&lang=js"
export * from "./InitializeSaveAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__